import requireAll from '@/helpers/requireAll';

const amueblado = {
	icon: 'fa-chair',
	text: 'Amueblado',
};

const cocina = (extra: string) => ({
	icon: 'fa-utensils',
	text: `Cocina con horno,${extra || ''} vajilla completa`,
});

const bath = {
	icon: 'fa-shower',
	text: 'Baño completo con termotanque',
};

const wifi = {
	icon: 'fa-wifi',
	text: 'Servicio de Wi-Fi',
};

const commonOptionals = [
	{
		icon: 'fa-bed',
		text: 'Servicio de Ropa Blanca',
	},
	{
		icon: 'fa-broom',
		text: 'Mucama',
	},
];

const dptoFeatures = (dormitorioText: string | string[]) => ([
	amueblado,
	{
		icon: 'fa-bed',
		text: dormitorioText,
	},
	cocina('heladera con freezer, microondas,'),
	{
		icon: 'fa-thermometer-half',
		text: [
			'2 estufas de tiro balanceado',
			'2 turboventiladores',
		],
	},
	bath,
	{
		icon: 'fa-tv',
		text: [
			'1 TV 24" en el dormitorio',
			'1 TV 39" en el living',
		],
	},
	wifi,
	{
		icon: 'fa-umbrella-beach',
		text: 'Galería vidriada fente al mar con mesas y sillas para disfrutar de la playa aunque llueva o haya viento!',
	},
]);

export default {
	'dpto-2.5-amb': {
		featureList: dptoFeatures([
			'1 dormitorio con 1 cama doble',
			'1 cucheta doble reforzada con 1 cama opcional',
			'Colchones Cannon de alta densidad',
		]),
		optionals: commonOptionals,
		photos: requireAll(require.context('@/assets/appartments/dpto-2.5-amb', false, /\.jpg$/)),
	},
	'dpto-3.5-amb': {
		featureList: dptoFeatures([
			'1 dormitorio con 1 cama doble',
			'1 dormitorio con 1 cama doble y 2 camas simples',
			'Colchones Cannon de alta densidad',
		]),
		optionals: commonOptionals,
		photos: requireAll(require.context('@/assets/appartments/dpto-3.5-amb', false, /\.jpg$/)),
	},
	loft: {
		featureList: [
			amueblado,
			{
				icon: 'fa-bed',
				text: [
					'1 cama doble',
					'1 cucheta doble',
				],
			},
			cocina('heladera,'),
			bath,
			{
				icon: 'fa-tv',
				text: 'TV por cable',
			},
			wifi,
			{
				icon: 'fa-umbrella-beach',
				text: 'Parque, parrillas, mesas, sillas y sombrillas con una genial vista al mar!',
			},
		],
		optionals: [
			{
				icon: 'fa-car-alt',
				text: 'Playa de estacionamiento',
			},
			...commonOptionals,
		],
		photos: requireAll(require.context('@/assets/appartments/loft', false, /\.jpg$/)),
	},
};
